import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  connect() {
    this.modal = new Modal(this.element);
    this.boundHandleHide = this.handleHide.bind(this);
    this.element.addEventListener("hide.bs.modal", this.boundHandleHide);
    this.modal.show();
  }

  handleHide() {
    this.element.remove();
  }

  disconnect() {
    this.element.removeEventListener("hide.bs.modal", this.boundHandleHide);
    if (this.modal) {
      this.modal.dispose();
    }
  }
}
